module.exports = __webpack_public_path__ + "static/media/frozen-root-beer-dt-en.a94d3db9.mp4";